import { IconDefinition } from '@fortawesome/free-solid-svg-icons';

export class MenuEntryModel {
    public constructor(
        public title: string,
        public action: () => void,
        public icon?: IconDefinition,
        public visible = true,
        public disabled = false,
    ) {}
}
